var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/search.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from 'clsx';
import debounce from 'lodash/debounce';
import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { changeSearch, clearSearch, clearSearchResults, setSearchAccount, showSearch, submitSearch } from 'soapbox/actions/search';
import AutosuggestAccountInput from 'soapbox/components/autosuggest-account-input';
import { Input } from 'soapbox/components/ui';
import SvgIcon from 'soapbox/components/ui/icon/svg-icon';
import { useAppSelector } from 'soapbox/hooks';
const messages = defineMessages({
  placeholder: {
    "id": "search.placeholder",
    "defaultMessage": "Search"
  },
  action: {
    "id": "search.action",
    "defaultMessage": "Search for \u201C{query}\u201D"
  }
});

function redirectToAccount(accountId, routerHistory) {
  return (_dispatch, getState) => {
    const acct = getState().getIn(['accounts', accountId, 'acct']);

    if (acct && routerHistory) {
      routerHistory.push("/@".concat(acct));
    }
  };
}

const Search = props => {
  const {
    autoFocus = false,
    autoSubmit = false,
    autosuggest = false,
    openInRoute = false
  } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const intl = useIntl();
  const value = useAppSelector(state => state.search.value);
  const submitted = useAppSelector(state => state.search.submitted);
  const debouncedSubmit = useCallback(debounce(() => {
    dispatch(submitSearch());
  }, 900), []);

  const handleChange = event => {
    const {
      value
    } = event.target;
    dispatch(changeSearch(value));

    if (autoSubmit) {
      debouncedSubmit();
    }
  };

  const handleClear = event => {
    event.preventDefault();

    if (value.length > 0 || submitted) {
      dispatch(clearSearchResults());
    }
  };

  const handleSubmit = () => {
    if (openInRoute) {
      dispatch(setSearchAccount(null));
      dispatch(submitSearch());
      history.push('/search');
    } else {
      dispatch(submitSearch());
    }
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSubmit();
    } else if (event.key === 'Escape') {
      var _document$querySelect, _document$querySelect2;

      (_document$querySelect = document.querySelector('.ui')) === null || _document$querySelect === void 0 ? void 0 : (_document$querySelect2 = _document$querySelect.parentElement) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.focus();
    }
  };

  const handleFocus = () => {
    dispatch(showSearch());
  };

  const handleSelected = accountId => {
    dispatch(clearSearch());
    dispatch(redirectToAccount(accountId, history));
  };

  const makeMenu = () => [{
    text: intl.formatMessage(messages.action, {
      query: value
    }),
    icon: require('@tabler/icons/search.svg'),
    action: handleSubmit
  }];

  const hasValue = value.length > 0 || submitted;
  const componentProps = {
    type: 'text',
    id: 'search',
    placeholder: intl.formatMessage(messages.placeholder),
    value,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    autoFocus: autoFocus,
    theme: 'search'
  };

  if (autosuggest) {
    componentProps.onSelected = handleSelected;
    componentProps.menu = makeMenu();
    componentProps.autoSelect = false;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "search",
    className: "sr-only",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.placeholder)), /*#__PURE__*/React.createElement("div", {
    className: "relative",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 7
    }
  }, autosuggest ? /*#__PURE__*/React.createElement(AutosuggestAccountInput, _extends({}, componentProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 144,
      columnNumber: 11
    }
  })) : /*#__PURE__*/React.createElement(Input, _extends({}, componentProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: "absolute inset-y-0 right-0 px-3 flex items-center cursor-pointer",
    onClick: handleClear,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SvgIcon, {
    src: require('@tabler/icons/search.svg'),
    className: classNames('h-4 w-4 text-gray-600', {
      hidden: hasValue
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(SvgIcon, {
    src: require('@tabler/icons/x.svg'),
    className: classNames('h-4 w-4 text-gray-600', {
      hidden: !hasValue
    }),
    "aria-label": intl.formatMessage(messages.placeholder),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 160,
      columnNumber: 11
    }
  }))));
};

export default Search;